import React, { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { addBreadcrumb } from '../../../redux/reducers/breadcrumb/actions'
import { useAppDispatch } from '../../../redux/hooks'
import { TrainingWorkout, TrainingWorkoutTypeEnum } from '../../../components/TrainingWorkout'

export const TrainingWorkoutList = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { id } = useParams()

  useEffect(() => {
    dispatch(addBreadcrumb({ label: location.state?.name, path: location.pathname }))
  }, [])

  return (
    <TrainingWorkout id={String(id)} type={TrainingWorkoutTypeEnum.TRAINING_BENCH} />
  )
}
